import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  border: 2px solid #979797;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  &:hover {
    .header .title {
      color: #E59134;
    }
  }
  .header {
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 80px;
    padding: 6px 0;
    margin: 0 24px;
    .title {
      color: #000;
      font: italic bold 26px 'Times new roman';
      display: block;
      flex-grow: 1;
    }
    button {
      background: none;
      border: 0;
      padding: 0;
      height: 30px;
      min-width: 30px;
      &.plus {
        background: url(/images/icon-plus.png) no-repeat center;
      }
      &.minus {
        background: url(/images/icon-minus.png) no-repeat center;
      }
    }
  }
  .content {
    width: 100%;
    padding: 0 24px 30px;
    p {
      color: #616161;
      font-size: 16px;
      line-height: 36px;
      margin: 0;
    }
  }
`

class Box extends Component {
  state = {
    status: false,
  }

  _toggle = (event) => {
    this.setState({'status': !this.state.status})
  }

  render () {
    const { title, children } = this.props;
    return (
      <Container>
        <div className="header" onClick={ this._toggle }>
          <strong className="title">{ title }</strong>
          <button className={ this.state.status ? 'minus' : 'plus' }></button>
        </div>
        {
          this.state.status && (
            <div className="content" >
              { children }
            </div>
          )
        }
        
      </Container>
    )
  }
}

Box.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default Box;
